import React, { Component } from 'react'
import './FooterCSS.css'

export default class Footer extends Component {
  render() {
    return (
    <React.Fragment>
    <div className='FS1'>
        <span>Authorised By</span>
        <div className='FS1-1'>
        <h5>Terms & Conditions</h5>
        <h6>Privacy Policies</h6>
        <a href='mailto:atharvkhandke6101999@gmail.com'><img src='https://www.washmartindia.in/static/media/mail.c11266cb.svg' alt='mail' width='40px' height='30px'></img></a>
        <a href='/'><img src='https://www.washmartindia.in/static/media/instagram.36131f42.svg' alt='mail' width='40px' height='30px'></img></a>
        <a href='/'><img src='https://www.washmartindia.in/static/media/youtube.efd6ed40.svg' alt='mail' width='40px' height='30px'></img></a>
        </div>
    </div>
    <div className='FS2'>
        <h5>Copyright @ WashMartIndia</h5>
        <div>
        <h6>From Biencaps _AK</h6>
        </div>
    </div>
        
    </React.Fragment>
    )
  }
}
